

import React from "react";
import { Box, Typography } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";

interface EventDateTimeProps {
    startDate: string;
    hasTime?: boolean;

}

const CellDate: React.FC<EventDateTimeProps> = ({ startDate, hasTime }) => {
    const formattedDate = dayjs(startDate).format("DD/MM/YYYY");
    const formattedStartTime = dayjs(startDate).format("HH:mm");
    //   const formattedEndTime = dayjs(endDate).format("HH:mm");

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                height: "100%", // Asegura el uso completo de la celda
                width: "100%", // Asegura que ocupe todo el ancho
                padding: "0", // Elimina padding adicional
            }}
        >
            <Box display="flex" alignItems="center" gap={1}>
                <Box display="flex" alignItems="center" gap={0.5}>
                    <EventIcon sx={{ fontSize: "14px", color: "#3d4f65" }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, fontSize: 14, color: "#3d4f65" }}>
                        {formattedDate}
                    </Typography>
                </Box>
                {hasTime && (
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <AccessTimeIcon sx={{ fontSize: "14px", color: "#616161" }} />
                        <Typography variant="body2" sx={{ fontWeight: 400, fontSize: 14, color: "#616161" }}>
                            {formattedStartTime}
                        </Typography>
                    </Box>
                )}
               
            </Box>
        </Box>
    );
};

export default CellDate;
